<template>
  <div v-if="loading">
    <div class="relative rounded-2xl overflow-hidden h-84 bg-grey-light-200">
      <Skeleton class="absolute inset-0 w-full h-full" />
    </div>
  </div>

  <div v-else-if="id">
    <div class="relative rounded-2xl overflow-hidden h-48 sm:h-64 md:h-80 bg-grey-light-200">
      <a
        :href="ensureHttps(domain)"
        @click.prevent="handleClick(domain)"
        target="_blank"
        class="block relative rounded-2xl overflow-hidden h-full bg-grey-light-200"
      >
        <img v-if="logo" :src="logo" :alt="name" class="w-full h-full object-cover object-center" loading="lazy" />
        <img v-else :src="DefaultImage" :alt="name" class="h-full object-center" loading="lazy" />

        <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent">
          <div class="absolute top-6 left-6">
            <div class="flex items-center gap-2 mb-2">
              <h2 class="text-white text-3xl font-bold">
                {{ name }}
              </h2>
              <span
                v-if="isNewStore(createdAt)"
                class="bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-1 rounded-full"
              >
                New
              </span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Skeleton } from '@/components/ui/skeleton';
import { isNewStore } from '@/utils/stores';
import DefaultImage from '@/assets/images/layup-logo.svg';

defineProps<{
  id: string | undefined;
  name: string | undefined;
  logo: string | undefined;
  createdAt: string | undefined;
  loading: boolean;
  domain: string | undefined;
}>();

const handleClick = (domain: string | undefined) => {
  window.open(ensureHttps(domain), '_blank');
};

const ensureHttps = (url: string | undefined): string => {
  if (!url) return '#';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `https://${url}`;
};
</script>
